import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import LoginWeixin from '../views/LoginWeixin.vue'
import IndexDetail from '../views/IndexDetail.vue'
Vue.use(Router)

let routes = []

const routerContext = require.context('./', true, /index\.js$/)

routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js、 不做任何处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  // 兼容 import export 和 require module.export 两种规范  Es modules  commonjs
  routes = [...routes, ...(routerModule.default || routerModule)]
})


routes = [{
  path: '/',
  component: Index,
  name: '首页'
}, {
  path: '/IndexDetail',
  component: IndexDetail,
  name: '详情'
}, {
  path: '/login',
  component: Login,
  name: '登录'
}, {
  path: '/loginWeixin',
  component: LoginWeixin,
  name: '登录微信绑定'
},
...routes
]


console.log(routes)
const router = new Router({
  //mode: 'hash',
  //base: process.env.BASE_URL,
  routes: routes
})

export default router
